<template>
  <v-container fluid class="client-access-page py-0">
    <v-row class="client-access-page__navbar">
      <v-col cols="12" md="4" class="pb-0">
        <v-img
          :src="require('../assets/logo.svg')"
          class="client-access-page__logo"
          eager
          contain
        />
      </v-col>
      <v-col cols="12" md="8" class="d-flex justify-end align-center pb-0 px-4 px-md-8">
        <v-btn
          outlined
          class="client-access-page__back-btn"
          @click="goHome"
        >
          {{ $t('backHome') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="client-access-page__content">
      <v-col cols="12" md="5">
        <div class="client-access-page__card">
          <p class="client-access-page__title text-neutra-bold mb-2">{{ $t('clientAccessTitle') }}</p>
          <p class="client-access-page__subtitle text-neutra-book mb-7">{{ $t('clientAccessSubtitle') }}</p>

          <v-form @submit.prevent="submitLogin">
            <v-text-field
              v-model="loginEmail"
              :label="$t('clientEmail')"
              type="email"
              hide-details="auto"
              class="client-access-page__input"
            />
            <v-text-field
              v-model="loginPassword"
              :label="$t('clientPassword')"
              type="password"
              hide-details="auto"
              class="client-access-page__input"
            />
            <p v-if="loginFeedback" class="mb-5 text-neutra-book text-granate">{{ loginFeedback }}</p>
            <v-btn
              outlined
              class="client-access-page__submit-btn"
              type="submit"
              :loading="loginSubmitting"
              :disabled="loginSubmitting"
            >
              {{ $t('clientLoginAction') }}
            </v-btn>
          </v-form>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ClientAccessPage',
  data() {
    return {
      loginEmail: '',
      loginPassword: '',
      loginSubmitting: false,
      loginFeedback: '',
    };
  },
  methods: {
    goHome() {
      window.location.hash = '#/';
    },
    async submitLogin() {
      this.loginFeedback = '';
      if (!this.loginEmail || !this.loginPassword) {
        this.loginFeedback = this.$t('clientLoginValidation');
        return;
      }
      this.loginSubmitting = true;
      await new Promise((resolve) => {
        setTimeout(resolve, 700);
      });
      this.loginSubmitting = false;
      this.loginFeedback = this.$t('clientLoginInvalid');
    },
  },
};
</script>

<style lang="scss">
  .client-access-page {
    min-height: 100vh;
    background: var(--bg-color);

    &__navbar {
      position: sticky;
      top: 0;
      z-index: 25;
      background: rgba(249, 248, 244, 0.94);
      border-bottom: 1px solid $s-dirty-white;
      padding: 4px 10px 8px;
    }

    &__logo {
      width: 230px;
      height: 90px;
      margin: 0 auto;
    }

    &__back-btn {
      border-color: var(--accent) !important;
      color: var(--text-color) !important;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    &__content {
      min-height: calc(100vh - 112px);
      align-items: center;
      justify-content: center;
      padding: 24px 12px 60px;
    }

    &__card {
      border: 1px solid var(--accent);
      background: rgba(255, 255, 255, 0.7);
      padding: 2rem 2rem 2.2rem;
    }

    &__title {
      font-size: 40px;
    }

    &__subtitle {
      font-size: 18px;
    }

    &__submit-btn {
      border-color: var(--accent) !important;
      color: var(--text-color) !important;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-top: 18px;
    }

    &__input {
      margin-bottom: 4px;
    }

    @media only screen and (max-width: 959px) {
      &__navbar {
        padding: 4px 0 8px;
      }

      &__logo {
        width: 190px;
        height: 82px;
      }

      &__content {
        min-height: auto;
        padding-top: 30px;
      }

      &__title {
        font-size: 32px;
      }
    }
  }
</style>
